const sounds = {
    positiveBeep: require("@/assets/audio/positive-interface-beep.wav"),
    beepFail: require("@/assets/audio/system-beep-buzzer-fail.wav")
}

export const sound = (soundName) => {
    const key = Object.keys(sounds).find(sound => {
        return sound == soundName
    })
    if (! key) {
        return 'sound not found'
    }
    let audio = new Audio(sounds[key])
    audio.play()

    return 'success'
}
